import NotFoundData from './NotFoundData'

export default NotFoundData